<div class="fo-footer">
    <div class="fo-footer__version">Version {{appVersion}}</div>
    <div class="logo_container">
        <ng-container *ngFor="let image of sponsorImages">
            <img class="fo-footer__sponsor" [src]="image" alt="" />
        </ng-container>
        <a *ngIf="logoecute" class="fo-footer__link" href="https://www.e-cute.it" target="_blank" rel="noopener noreferrer">
            <img class="logo_footer" [src]="logoecute" alt="e-cute" />
        </a>
        <hr *ngIf="logoecute" class="divisor" />
        <a class="fo-footer__link" href="http://www.3punto6.com" target="_blank" rel="noopener noreferrer">
            <img class="logo_footer logo_footer--3punto6" src="assets/images/logos/logo3punto6.svg" alt="3punto6" />
        </a>
    </div>
</div>
